module.exports = __webpack_public_path__ + "static/sheepmain-748f96928776baa3e30b2a8122e60a63.jpeg";